import { Box, DateField, TextFieldSize } from '@bechtel/gds';
import '@bechtel/gds/dist/index.css';
import { t } from '@lingui/macro';
import { Field } from 'formik';
import React, { FC } from 'react';

export const DateRangeFilter: FC = () => {
  return (
    <Box pl={{ sm: '000' }} pt={{ sm: '400' }} pb={{ sm: '500' }} mt={{ sm: '200' }}>
      <Field name="startDate">
        {({ form }) => {
          return (
            <Box pr={{ sm: '400' }} flexDirection={{ sm: 'column' }}>
              <DateField
                selectsStart
                maxDate={new Date(form.values.endDate)}
                selected={new Date(form.values.startDate)}
                onChange={(date) => {
                  form.setFieldValue('startDate', date);
                }}
                showPopperArrow={false}
                placeholderText={t`Start Date`}
                size={TextFieldSize.SMALL}
              />
            </Box>
          );
        }}
      </Field>
      <Field name="endDate">
        {({ form }) => {
          return (
            <Box flexDirection={{ sm: 'column' }}>
              <DateField
                selectsEnd
                minDate={new Date(form.values.startDate)}
                selected={new Date(form.values.endDate)}
                onChange={(date) => {
                  form.setFieldValue('endDate', date);
                }}
                popperPlacement="bottom-end"
                showPopperArrow={false}
                placeholderText={t`End Date`}
                size={TextFieldSize.SMALL}
              />
            </Box>
          );
        }}
      </Field>
    </Box>
  );
};

export default DateRangeFilter;
